import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  MOBILE_MIN_WIDTH,
  MOBILE_SMALL_MAX_WIDTH,
  MOBILE_SMALL_MIN_WIDTH,
  TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH,
} from 'constants';
import { useEffect, useState } from 'react';

const isMobile = (width) => {
  return width >= MOBILE_MIN_WIDTH && width < MOBILE_MAX_WIDTH;
};
const isSmallMobile = (width) => {
  return width >= MOBILE_SMALL_MIN_WIDTH && width <= MOBILE_SMALL_MAX_WIDTH;
};

const isTablet = (width) => {
  return width >= TABLET_MIN_WIDTH && width < TABLET_MAX_WIDTH;
};

const isDesktop = (width) => {
  return width >= DESKTOP_MIN_WIDTH;
};

export function useDetectDevice() {
  const getWindowSize = () => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  const [windowSize, setWindowSize] = useState(getWindowSize);

  const { width } = windowSize || {};

  const isMobileCSR = isMobile(width);
  const isSmallMobileCSR = isSmallMobile(width);
  const isTabletCSR = isTablet(width);
  const isDesktopCSR = isDesktop(width);
  const isAndroid =
    typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

  const handleResize = () => {
    const newWindowSize = getWindowSize();
    setWindowSize(newWindowSize);
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile: isMobileCSR,
    isSmallMobile: isSmallMobileCSR,
    isTablet: isTabletCSR,
    isDesktop: isDesktopCSR,
    windowSize,
    isAndroid,
  };
}
